/**
 * Build with Customer Page
 * Main page component that renders the Build with Customer dashboard
 */

import React from "react";
import { useSearchParams } from "react-router-dom";
import { BuildWithCustomerContainer } from "../components/BuildWithCustomer/BuildWithCustomerContainer";

const BuildWithCustomerPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const squadId = searchParams.get("squadId") || undefined;
  const squadName = searchParams.get("squadName") || "Alpha Security Squad";

  // useEffect(() => {
  //   logPageView('BuildWithCustomerPage', {
  //     squadId,
  //     squadName
  //   });
  // }, [squadId, squadName]);

  return (
    <div style={{ minHeight: "100vh" }}>
      <BuildWithCustomerContainer
        squadId={squadId}
        squadName={squadName}
      />
    </div>
  );
};

export default BuildWithCustomerPage;
